import Cookies from 'js-cookie';
import { v4 } from 'uuid';
import { EXTERNAL_CUSTOMER_ID } from '@yme/utils/constants';
export const getCustomerId = (customerIdKey = EXTERNAL_CUSTOMER_ID) => {
    let customerId = Cookies.get(customerIdKey);
    if (!customerId) {
        customerId = v4();
        Cookies.set(customerIdKey, customerId);
    }
    return customerId;
};
